import { Component, OnInit, Input, Output, EventEmitter, ElementRef, inject } from "@angular/core";
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { SesionService } from "src/app/services/sesion.service";
import { CommonModule } from "@angular/common";
import { WebServicesService } from "../../services/web-services.service";
import { GeneralService } from "../../services/general.service";
import { DeviceDetectorService } from "ngx-device-detector";
import Swal from "sweetalert2";
import { ViewChild, OnChanges, ViewEncapsulation } from "@angular/core";
import { SeoService } from "../../services/seo.service";
import { Title } from "@angular/platform-browser";
import { AllLocalStorageService } from "../../services/all-local-storage.service";
import { NgbModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { Texto_sitio } from "src/assets/text_site";
import { CdTimerModule } from 'angular-cd-timer';
import { MenuLateralCelularComponent } from "../menu-lateral-celular/menu-lateral-celular.component";
import { environment } from "src/environments/environment";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from "rxjs";

@Component({
  selector: "app-header-site",
  templateUrl: "./header-site.component.html",
  styleUrls: ["./header-site.component.scss"],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    CdTimerModule,
    MenuLateralCelularComponent,
    TranslateModule
  ],
  providers: [
    TranslateService,
    SesionService,
    WebServicesService,
    DeviceDetectorService,
    SeoService,
    GeneralService,
    AllLocalStorageService,
    Texto_sitio,
    NgbModal
  ]

})
export class HeaderSiteComponent implements OnInit, OnChanges {
  @Input() timeBuy: any;
  @Input() ocultarTimer = false;
  @Input() eliminarTimer = false;
  @Input() modal: boolean = false;
  @Input() _logo_custom!: any;
  @Input() _load: any;
  @Input() _home: any;
  @Input() cerrarMenuCelular: number;
  @Output() eventClick = new EventEmitter();
  @Output("cerrarModal") cerrarModal: EventEmitter<any> = new EventEmitter();
  @Output("abrirLogin") abrirLogin: EventEmitter<any> = new EventEmitter();
  @Output("timerEnd") timerEnd: EventEmitter<any> = new EventEmitter();
  @ViewChild("basicTimer") sadsadsad: any;


  menu: any = false;
  styles: any;
  complement: any
  linkHelp: any = "es/ayuda";
  deviceInfo = null;
  timer = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;
  mostrarModal = false;
  timeStartBuy: any = 10;
  contadorDiferenciaTiempo = 0;
  mostrarTimer = false;
  todoElIdioma: any;
  idiomaActual = false; // false = español, true =  inglés
  contadorEliminar = 0;

  nameInterval: any;
  checkComplLogin: boolean = false;
  lang: string;
  urlCdn = environment.urlCdn
  private deviceService = inject(DeviceDetectorService);


  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public sesion: SesionService,
    public ws: WebServicesService,
    // private deviceService: DeviceDetectorService,
    public seo: SeoService,
    public titleBrowser: Title,
    public toolService: GeneralService,
    private allLocalStorageService: AllLocalStorageService,
    private modalService: NgbModal,
    private translateService: TranslateService,
    private general: GeneralService
  ) {
    // this.todoElIdioma = this.texto_sitio.spain;

    this.lang = this.translateService.currentLang;




    this.sesion.userSubject.asObservable().subscribe((user) => {
      this.sesion.user = user
    })
    // Para el contenedor transfer no posee complemento
    if (!this.activatedRoute.snapshot.params.complement && this.activatedRoute.snapshot.url.join('/').includes("/transfer")) {
      this.ws.newComplemt = "transfer";
    } else {
      this.ws.newComplemt = this.activatedRoute.snapshot.params.complement ? this.activatedRoute.snapshot.params.complement : "pasajes";
    }

    this.checkComplementForLogin();
    this.general.asignarEstilos(this.ws.newComplemt);

    if (this.lang == 'es') {
      this.idiomaActual = false;
    } else {
      this.idiomaActual = true;
    }


    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.ws.isMobile = this.deviceService.isMobile();
    this.ws.isTablet = this.deviceService.isTablet();
    this.ws.isDesktopDevice = this.deviceService.isDesktop();


  }

  toIndex() {
    this.router.navigate(["/"]);
  }

  openLogin() {
    if (!this.modal) {

      this.router.navigate(["/es/clientes/login"]);
    } else {
      this.eventClick.emit({ action: "login" });
    }
  }

  ngOnChanges() {
    if (this.ocultarTimer == true) {
      // console.log("ocultar timer 1");
      this.mostrarTimer = false;
    }

    if (this.eliminarTimer == true) {
      // console.log("ocultar timer 2");
      this.mostrarTimer = false;

      this.seDetiene();
    }
  }

  openRegister() {
    if (!this.modal) {
      this.router.navigate(["/es/clientes/register"]);
    } else {
      this.eventClick.emit({ action: "register" });
    }
  }

  viewMenu() {
    this.menu = !this.menu;
  }

  cerrarModalTimeOut() {
    this.mostrarModal = false;
    const url = this.allLocalStorageService.obtenerUrlVolver(
      this.ws.newComplemt
    );
    this.router.navigateByUrl(url);
  }

  iniciarSesion() {
    if (
      this.activatedRoute.snapshot.routeConfig?.path.indexOf("ida") != -1 ||
      this.activatedRoute.snapshot.routeConfig?.path.indexOf("reg") != -1 ||
      this.activatedRoute.snapshot.routeConfig?.path.indexOf("pago") != -1
    ) {
      this.abrirLogin.emit("abrir");
    } else {

      this.router.navigateByUrl("es/clientes/login");
    }
  }

  /**
   * Checkea los complementos para poder mostrar el boton de ingresar al login
   */
  checkComplementForLogin() {
    this.checkComplLogin = this.ws.newComplemt == 'pasajes' || this.ws.newComplemt == 'transfer' || this.ws.newComplemt == 'movired' ? true : false;
  }

  validacionUltConexion(cmpl) {
    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();

    const dateCompare = { day, month, year };
    var clave_: any = (typeof localStorage !== 'undefined') ? localStorage.getItem(`JSMldjs37592kLoiNM-${cmpl}`) : false;
    if (!clave_) {
      (typeof localStorage !== 'undefined') ? localStorage.setItem(`JSMldjs37592kLoiNM-${cmpl}`, JSON.stringify(dateCompare)) : false;
    } else {
      let dateLocalCompare: any = (typeof localStorage !== 'undefined') ? localStorage.getItem(`JSMldjs37592kLoiNM-${cmpl}`) : false;
      try {
        dateLocalCompare = JSON.parse(dateLocalCompare);
      } catch (error) { }
      const fechaLocal = dateLocalCompare.day + dateLocalCompare.month + dateLocalCompare.year;
      const fechaActual = dateCompare.day + dateCompare.month + dateCompare.year;
      if (fechaLocal < fechaActual) {
        (typeof localStorage !== 'undefined') ? localStorage.setItem(`JSMldjs37592kLoiNM-${cmpl}`, JSON.stringify(dateCompare)) : false;
      }
    }
  }

  verifyLastSession() {
    const lastSession = (typeof localStorage !== 'undefined') ? localStorage.getItem("XpQr9Tf42mLn7W") : false;
    if (lastSession) {
      const lastSessionDate = Number(lastSession); // convert seconds stored to number for comparison
      const currentDate = Math.floor(Date.now() / 1000); // get current time in seconds

      // if the difference is greater than 1 month, log the user out
      if (currentDate - lastSessionDate > 2592000) {
        this.sesion.deleteUser();

        // create alert
        Swal.fire({
          title: 'Tu sesión ha expirado',
          text: 'Por favor, inicia sesión nuevamente',
          icon: 'warning',
          confirmButtonColor: 'var(--primary)',
          confirmButtonText: 'Ok',
        }).then((data) => {
          if (data.isConfirmed) {
            this.router.navigateByUrl("/es/clientes/login");
          }
        });

      }
    }
  }


  async ngOnInit(): Promise<void> {
    // verify last session
    this.verifyLastSession();

    this.complement = this.toolService.checkComplement(this.ws.newComplemt)
    // this.eliminarPorDia();
    this.sesion.getUser();
    // consultar por la marca de tiempo
    let day = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    let hour: any = new Date().getHours();
    let minutes: any = new Date().getMinutes();
    let hourAndMinutes: any = `${hour}${minutes.toString().length == 1 ? "0" + minutes : minutes}`;
    hourAndMinutes = Number(hourAndMinutes);
    let fechaActual = day + month + year + hourAndMinutes;
    let fechaHistorial: any = (typeof localStorage !== 'undefined') ? localStorage.getItem("H1ST0R14L") : false;
    if (fechaHistorial) {
      fechaHistorial = Number(fechaHistorial);
      fechaActual = Number(fechaActual);
      let totalResta: Number = fechaActual - fechaHistorial;
      let eliminar_viaje_ida = (typeof localStorage !== 'undefined') ? localStorage.getItem("B0RR4R_V14J3_1D4") : false;
      let se_acabo_el_tiempo = (typeof localStorage !== 'undefined') ? localStorage.getItem("S3_4C4B0_3L_T13MP0") : false;

      if (se_acabo_el_tiempo) {
        localStorage.removeItem("S3_4C4B0_3L_T13MP0");
        localStorage.removeItem("H1ST0R14L");
        this.eliminarDataLocalStorage();
        this.seDetiene();
      }

      if (Number(totalResta) >= 10 || Number(totalResta) <= -10) {
        if (eliminar_viaje_ida) {
          this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
          localStorage.removeItem("B0RR4R_V14J3_1D4");
        }
        localStorage.removeItem("H1ST0R14L");
        this.eliminarDataLocalStorage();

        this.seDetiene();
      }
    }

    this.validacionUltConexion(this.ws.newComplemt);

    // console.log("que pasa con esta cosa: iniciar_contador: ", this.ws.newComplemt);

    // console.log("FISKNdks-${this.ws.newComplemt}: ", localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`));
    // console.log(localStorage.getItem(`iniciar_contador-${this.ws.newComplemt}`));
    if (typeof localStorage !== 'undefined') {
      if (localStorage.getItem(`iniciar_contador-${this.ws.newComplemt}`)) {
        // console.log("entramos al primer if");
        localStorage.removeItem(`iniciar_contador-${this.ws.newComplemt}`);
        this.timeStartBuy = localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`);
        // console.log("el tiempo a contar: ", this.timeStartBuy);
        this.mostrarTimer = true;
        // console.log("contador 1");

        // evitar que se reinicie el contador 600
        this.contador(600);
      } else {
        const data = localStorage.getItem("eliminar_timer");
        if (localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`) && data) {
          this.mostrarTimer = true;
          // console.log("contador 2");
          this.contador(Number(localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`)) + 1);
        } else {
          localStorage.removeItem(`FISKNdks-${this.ws.newComplemt}`);
        }
      }
    }

    const url = this.activatedRoute.snapshot.routeConfig.path;
    if (url.indexOf("compra_exitosa") != -1) {
      // console.log("ocultar timer 3");
      this.mostrarTimer = false;
      this.eliminarDataLocalStorage();
      return;
      //! esto se comentó ya que causaba un bucle
      // this.ngOnInit();
    }

    // if (isPlatformBrowser()) {
    //   if (!this.deviceService.isDesktop()) {
    //     let HeaderTag = this.el.nativeElement.querySelector("nav");
    //     HeaderTag.classList.remove("p-0");
    //     HeaderTag.classList.remove("floating-nav");
    //     HeaderTag.classList.remove("p-0");
    //     HeaderTag.classList.remove("container-xxl");
    //     //HeaderTag.classList.add("fixed-top");
    //   }

    //   this.activatedRoute.params.subscribe((value) => {
    //     let langSession = this.sesion.getLanguage();
    //     let lang = value["lang"];
    //     if (lang) {
    //       let assig = langSession && langSession != lang ? langSession : lang;
    //       this.sesion.lang = assig;
    //       this.sesion.setLanguage(assig);
    //     }
    //   });
    // }

    // if (this.lang == "es") {
    //   this.todoElIdioma = this.texto_sitio.spain;
    // } else {
    //   this.todoElIdioma = this.texto_sitio.english;
    // }

    const dataPago = this.allLocalStorageService.obtenerDataPago(this.ws.newComplemt);
    const dataAsiento = this.allLocalStorageService.obtenerAsietnosIda(this.ws.newComplemt);
    const historial = (typeof localStorage !== 'undefined') ? localStorage.getItem("H1ST0R14L") : false;
    if (!dataPago && !dataAsiento && !historial && this.ws.newComplemt != 'transfer') {
      // console.log("ocultar timer 4");
      this.mostrarTimer = false;
      if (dataPago || dataAsiento) {

        this.seDetiene();
      }
    }
  }

  // eliminarPorDia() {
  //   let day: any = new Date().getDate();
  //   let month: any = new Date().getMonth() + 1;
  //   let year: any = new Date().getFullYear();
  //   day = day.toString();
  //   month = month.toString();
  //   year = year.toString();
  //   let amount = day + month + year;
  //   amount = Number(amount);
  //   const amount_last = (typeof localStorage !== 'undefined') ? localStorage.getItem("amount_last") : false;
  //   if (!amount_last) {
  //     (typeof localStorage !== 'undefined') ? localStorage.setItem("amount_last", amount) : "" ;
  //   }
  //   if (amount > amount_last) {
  //     if(typeof localStorage !== 'undefined'){
  //       localStorage.clear();
  //       localStorage.setItem("amount_last", amount);
  //     }
  //   }
  // }

  contador(count) {
    // console.log("se llama a contador: ", count);
    if (count < 0) {
      this.seDetiene();
      // console.log("ocultar timer 5");
      this.mostrarTimer = false;
    }
    const dataCountDiference = count - 1;
    localStorage.setItem(`FISKNdks-${this.ws.newComplemt}`, `${dataCountDiference}`);
    this.timeStartBuy = Number(localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`));
    // console.log(this.timeStartBuy);
  }

  seAcaboElTiempo() {
    // console.log("ocultar timer 6");
    this.mostrarTimer = false;
    this.eliminarDataLocalStorage();
  }

  async mostrarAlertaTimer() {
    if (this.ws.newComplemt !== 'transfer') {
      if (window.location.href.indexOf("/pago") != -1 && window.location.href.indexOf("/transfer/") == -1) {
        let expiroElTiempo: any;
        let ustedDispone: any;

        expiroElTiempo = await this.general.getTranslation('tarjeta_pago.expiroElTiempo');
        ustedDispone = await this.general.getTranslation('tarjeta_pago.ustedDispone');
        Swal.fire({
          title: expiroElTiempo,
          text: ustedDispone,
          icon: "warning",
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "var(--primary)",
          confirmButtonText: "Ok",
        }).then((data) => {
          if (data.isConfirmed == true) {
            this.cerrarModal.emit("si");
            this.eliminarDataLocalStorage();
            this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
            this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
            this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
            this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
            this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
            this.allLocalStorageService.eliminarDataPago(this.ws.newComplemt);
            this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
            this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);
            this.modalService.dismissAll();
            const url = this.activatedRoute.snapshot.routeConfig.path.indexOf("pago");
            if (url != -1) {
              const newUrl = this.allLocalStorageService.obtenerUrlVolver(this.ws.newComplemt);
              this.router.navigateByUrl(newUrl);
            }
          }

        });
      }
    } else {
      //* Caso: Transfer
      if (window.location.href.indexOf("/pago") != -1) {
        let expiroElTiempo: any;
        let ustedDispone: any;

        expiroElTiempo = await this.general.getTranslation('tarjeta_pago.expiroElTiempo');
        ustedDispone = await this.general.getTranslation('tarjeta_pago.ustedDispone');
        Swal.fire({
          title: expiroElTiempo,
          text: ustedDispone,
          icon: "warning",
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "var(--primary)",
          confirmButtonText: "Ok",
        }).then((data) => {
          if (data.isConfirmed == true) {
            this.cerrarModal.emit("si");
            this.eliminarDataLocalStorage();
            // this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
            this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
            // this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
            this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
            // this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
            this.allLocalStorageService.eliminarDataPago(this.ws.newComplemt);
            // this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
            this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);
            this.modalService.dismissAll();
            const url = this.activatedRoute.snapshot.routeConfig.path.indexOf("pago");
            if (url != -1) {
              const newUrl = this.allLocalStorageService.obtenerUrlVolver(this.ws.newComplemt);
              this.router.navigateByUrl(newUrl);
            }
          }
        });
      }
    }
  }

  seDetiene() {
    let dataUrl = this.activatedRoute.snapshot.routeConfig.path;
    if (!localStorage.getItem(`AKSMSNjhfi37443-${this.ws.newComplemt}`)) {
      if (dataUrl.indexOf("pago") != -1) {
        this.timerEnd.emit("fin");
        this.mostrarAlertaTimer()
        this.cerrarModal.emit("si");
        this.eliminarDataLocalStorage();
        this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
        this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
        this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);
        this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
        this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
        this.allLocalStorageService.eliminarDataPago(this.ws.newComplemt);
        this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
        this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);
      }
    }

    let asientosIda = this.allLocalStorageService.obtenerAsietnosIda(this.ws.newComplemt);;
    let asientosViajeIda = this.allLocalStorageService.obtenerViajeIda(this.ws.newComplemt);
    let asientosHistorialIda = this.allLocalStorageService.obtenerHistorialViajeIda(this.ws.newComplemt);
    let dataPago = this.allLocalStorageService.obtenerDataPago(this.ws.newComplemt);
    let datosClientePago = this.allLocalStorageService.obtenerDatosClientePAgo(this.ws.newComplemt);
    if (asientosIda || asientosViajeIda || asientosHistorialIda || dataPago || datosClientePago) {
      this.eliminarDataLocalStorage();
    }
  }

  eliminarDataLocalStorage() {
    this.mostrarTimer = false;
    this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
    //this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
    //this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
    //this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
    //this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarDatosClientePago(this.ws.newComplemt);
    localStorage.removeItem(`4pd4t3c1t135p40g4355-${this.ws.newComplemt}`);
    localStorage.removeItem(`formClp-${this.ws.newComplemt}`);
    localStorage.removeItem(`ch1l3p4s4g3sUs3435-${this.ws.newComplemt}`);
    localStorage.removeItem("latest");
    localStorage.removeItem(`FISKNdks-${this.ws.newComplemt}`);
    localStorage.removeItem(`AKSMSNjhfi37443-${this.ws.newComplemt}`);
    this.contadorEliminar = this.contadorEliminar + 1;
    if (this.contadorEliminar <= 10) {
      this.seDetiene();
    }
  }

  goToBuy() {
    if (this.ws.newComplemt === 'transfer' || this.ws.newComplemt == 'transfer-pruebas') {
      this.router.navigateByUrl(
        `${this.sesion.lang}/transfer/pago`
      );
    } else {
      this.router.navigateByUrl(
        `${this.sesion.lang}/${this.ws.newComplemt}/pago`
      );
    }
  }

  ngAfterViewInit() {
    const _url: string = this.activatedRoute.snapshot.url.toString();
    if (this.ws.newComplemt !== 'transfer') {
      if (_url.includes("pago") || _url.includes("ida") || _url.includes("reg")) {
        this.toolService.getComplement(this.activatedRoute).then(
          (response) => {
            this.ws.newComplemt = response ? response : "pasajes";
          },
          (err) => { }
        );
      }
    }
    if (typeof window !== 'undefined') {
      if (window.location.href.indexOf("/pago") != -1) {
        setTimeout(() => {
          let complemnt = (typeof localStorage !== 'undefined') ? localStorage.getItem(`FISKNdks-${this.ws.newComplemt}`) : false;
          if (complemnt == null) {
            this.seDetiene();
          }
        }, 5000);
      }
    }
  }

  actionAccount(option: any) {
    if (option.action == "logout") {
      this.sesion.deleteAccessToken();
      this.sesion.deleteUser();

      this.router.navigate([`/${this.lang}`]);
    } else {

      this.router.navigate([`${option.action}`]);
    }
  }

  act_salir(option: any) {
    if (this.activatedRoute.snapshot.routeConfig.path.indexOf("cuenta") != -1) {
      if (option == "logout") {
        this.sesion.deleteUser();

        this.router.navigate([`${this.lang}`]);
      } else {

        this.router.navigate([`${option.action}`]);
      }
    } else {
      this.sesion.deleteUser();
    }
  }


  modalOpen(modalBasic) {
    this.modalService.open(modalBasic, {
      windowClass: "custom-class",
    });
  }

  cerrarModalMenu() {
    let element: HTMLElement = document.getElementsByClassName("btn-close")[0] as HTMLElement;
    element.click();
  }

  // cambiarIdioma(type) {
  //   let url = window.location.href;
  //   if (type && type == 0) {
  //     url = url.replace("/en/", "/es/");
  //   } else {
  //     url = url.replace("/es/", "/en/");
  //   }
  //   window.location.href = url;
  // }

  ir(url) {
    // if (window.location.href.indexOf("/pago") != -1) {
    //   this.abrirLogin.emit("abrir-login-modal");
    //   return;
    // }

    if (url == "/no-mover") {
      if (window.location.href.indexOf("/cuenta/") != -1) {
        this.sesion.deleteUser();
        this.router.navigateByUrl("/es/bus");
      } else {
        this.sesion.deleteUser();
      }
      return;
    }

    this.router.navigateByUrl(`/${this.lang}` + url);
  }

  asd() {
    this.allLocalStorageService.eliminarSesionID(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeIda(this.ws.newComplemt);
    this.allLocalStorageService.eliminarAsientosVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarViajeVuelta(this.ws.newComplemt);
    this.allLocalStorageService.eliminarHistorialViajeIda(this.ws.newComplemt);

    this.router.navigateByUrl("/");
  }


  async cambiarIdioma(_lang: string) {
    let langSegments: Array<string> = [];
    let newUrl: string = '';

    await lastValueFrom(this.translateService.use(_lang));
    this.lang = this.translateService.currentLang;

    if (!this.activatedRoute.snapshot.params.lang) {
      this.router.navigateByUrl("/" + _lang).then(() => {
      });
      return;
    }

    newUrl = this.router.url;
    langSegments = this.translateService.getLangs();

    for (const segment of langSegments) {
      if (newUrl.includes('/' + segment)) {
        this.router.navigateByUrl(newUrl.replace(segment, `/${this.lang}`))
        return;
      }
    }
  }

  asignarEstilos(complemento) {
    try {
      switch (complemento) {
        case "pasajes":
          this.styles = [
            { name: "primary", value: "#002172" },
            { name: "principal-texto", value: "#002172" },
            { name: "secondary", value: "#e52062" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "pullman-lago-penuelas":
          this.styles = [
            { name: "primary", value: "#064491" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#fe6307" },
            { name: "barra", value: "#fe6307" },
            { name: "bg", value: "#064491" },
          ];
          break;
        case "chile-pruebas":
          this.styles = [
            { name: "primary", value: "#6732d4" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#ffffff" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "transfer-pruebas":
          this.styles = [
            { name: "primary", value: "#6732d4" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#ffffff" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "narbus":
          this.styles = [
            { name: "primary", value: "#168d16" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#009242" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-rcb":
          this.styles = [
            { name: "primary", value: "#168d16" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#009242" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-rimar":
          this.styles = [
            { name: "primary", value: "#A51F00" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#E41F17" },
            { name: "barra", value: "#A51F00" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-expreso-del-sur":
          this.styles = [
            { name: "primary", value: "#1d52a0" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#da1818cf" },
            { name: "barra", value: "#1d52a0" },
            { name: "bg", value: "#1d52a0" },
          ];
          break;
        case "buses-igillaima":
          this.styles = [
            { name: "primary", value: "#168d16" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#009242" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "turismo-zaahj":
          this.styles = [
            { name: "primary", value: "#009c90" },
            { name: "principal-texto", value: "#ffffff" },
            { name: "secondary", value: "#FFD24C" },
            { name: "barra", value: "#009c90" },
            { name: "bg", value: "#009c90" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-pullmantur":
          this.styles = [
            { name: "primary", value: "#4b457f" },
            { name: "principal-texto", value: "#ffffff" },
            { name: "secondary", value: "#293462" },
            { name: "barra", value: "#4b457f" },
            { name: "bg", value: "#4b457f" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-altas-cumbres":
          this.styles = [
            { name: "primary", value: "#112497" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#ff8f45" },
            { name: "barra", value: "#112497" },
            { name: "bg", value: "#142486" },
          ];
          break;
        case "buses-paravias":
          this.styles = [
            { name: "primary", value: "#0da25e" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#1CD6CE" },
            { name: "barra", value: "#0da25e" },
            { name: "bg", value: "#0da25e" },
          ];
          break;
        case "buses-viajaqui":
          this.styles = [
            { name: "primary", value: "#00a9ef" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#9bca3b" },
            { name: "barra", value: "#0da25e" },
            { name: "bg", value: "#0da25e" },
          ];
          break;
        case "buses-transantin":
          this.styles = [
            { name: "primary", value: "#1d52a0" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#0F2C67" },
            { name: "barra", value: "#1d52a0" },
            { name: "bg", value: "#1d52a0" },
          ];
          break;
        case "cikbus":
          this.styles = [
            { name: "primary", value: "#1d52a0" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#da1818cf" },
            { name: "barra", value: "#1d52a0" },
            { name: "bg", value: "#1d52a0" },
          ];
          break;
        case "ruta-bus-78":
          this.styles = [
            { name: "primary", value: "#ee0f0fcf" }, // barra
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#A71B1B" }, // boton
            { name: "barra", value: "#1d52a0" },
            { name: "bg", value: "#1d52a0" },
          ];
          break;
        case "hualpen":
          this.styles = [
            { name: "primary", value: "#FE7511" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#FF5403" },
            { name: "barra", value: "#FE7511" },
            { name: "bg", value: "#ff8227" },
          ];
          break;
        case "buses-jeldres":
          this.styles = [
            { name: "primary", value: "#168d16" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#105652" },
            { name: "barra", value: "#168d16" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "buses-casther":
          this.styles = [
            { name: "primary", value: "#FF8300" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#FF5403" },
            { name: "barra", value: "#FF8300" },
            { name: "bg", value: "orange" },
          ];
          break;
        case "ruta78":
          this.styles = [
            { name: "background-color: #168d16 !important;" },
            { name: "primary", value: "#E43E28" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#168d16" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "buses-erbuc":
          this.styles = [
            { name: "background-color: #168d16 !important;" },
            { name: "primary", value: "#1d52a0" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#168d16" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "pullman-setter":
          this.styles = [
            { name: "background-color: #168d16 !important;" },
            { name: "primary", value: "#261d31" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#168d16" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "buses-sanhueza":
          this.styles = [
            { name: "background-color: #168d16 !important;" },
            { name: "primary", value: "#C61421" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#033E60" },
            { name: "barra", value: "#168d16" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "movired":
          this.styles = [
            { name: "background-color: #CE0028 !important;" },
            { name: "primary", value: "#CE0028" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#CE0028" }, //btn BUSCAR
            { name: "barra", value: "#CE0028" },
            { name: "bg", value: "#51ad51" },
          ];
          break;
        case "chi-ar":
          this.styles = [
            { name: "primary", value: "#D53331" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#D53331" },
            { name: "barra", value: "#D53331" },
            { name: "bg", value: "#0d7be2" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "buses-sol-del-pacifico":
          this.styles = [
            { name: "primary", value: "#D53331" },
            { name: "principal-texto", value: "#6732d4" },
            { name: "secondary", value: "#D53331" },
            { name: "barra", value: "#D53331" },
            { name: "bg", value: "#0d7be2" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "pullman-jc":
          this.styles = [
            { name: "primary", value: "#ff0000" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#0a009b" },
            { name: "barra", value: "#ff0000" },
            { name: "bg", value: "#ff0000" },
          ];
          break;
        case "marga-taqsa":
          this.styles = [
            { name: "primary", value: "#e67824" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#fab80e" },
            { name: "barra", value: "#e67824" },
            { name: "bg", value: "#e67824" },
          ];
          break;
        case "buses-tra":
          this.styles = [
            { name: "primary", value: "#3CB371" },
            { name: "principal-texto", value: "white" },
            { name: "secondary", value: "#C00000" },
            { name: "barra", value: "#C00000" },
            { name: "bg", value: "#3CB371" },
          ];
          break;
        case "cikbus-express":
          this.styles = [
            { name: "primary", value: "#002172" },
            { name: "principal-texto", value: "#002172" },
            { name: "secondary", value: "#e52062" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        case "expreso-santa-cruz":
          this.styles = [
            { name: "primary", value: "#002172" },
            { name: "principal-texto", value: "#002172" },
            { name: "secondary", value: "#e52062" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
        default:
          this.styles = [
            { name: "primary", value: "#002172" },
            { name: "principal-texto", value: "#002172" },
            { name: "secondary", value: "#e52062" },
            { name: "barra", value: "#EFF1F6" },
            { name: "bg", value: "#e91e63" },
            { name: "principal-label", value: "#6a6a6a" },
          ];
          break;
      }
    } catch (error) {

    }

    try {
      this.styles.forEach((data) => {
        document.documentElement.style.setProperty(`--${data.name}`, data.value);
      });
    } catch (error) {

    }
  }
}

